import { actionTypes } from '@/core/constants'
import DocumentosUrlBuilder from '@/core/utils/factory/documentos/DocumentosUrlBuilder'
import DocumentoAnexosApiClient from '@/core/apiclient/documentos/anexos/DocumentoAnexosApiClient'

function getApiClient(obj) {
	const urlBuilder = new DocumentosUrlBuilder(obj.tipo)
	return new DocumentoAnexosApiClient(urlBuilder)
}

export default {
	async [actionTypes.DOCUMENTOS.ANEXO.INSERIR_GENERICO](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.inserirAnexo(objt.anexo)
		return data
	},
}
